<template>
  <el-tabs v-model="activeTab" type="border-card" class="system-setting-tabs">
    <el-tab-pane name="basic" label="Basic">
      <SystemSettingBasic :item="item" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="email" label="Email" lazy>
      <SystemSettingEmail :item="item.email" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="order" label="Container" lazy>
      <SystemSettingContainer :item="item.container" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="driver" label="Driver" lazy>
      <SystemSettingDriver :item="item.driver" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="carrier-profile" label="Carrier Profile" lazy>
      <CarriersProfile :modal="false" :own="true" />
    </el-tab-pane>
    <el-tab-pane name="quote-engine" label="Quote Engine" lazy>
      <SystemSettingQuoteEngine
        :item="item.quote_engine"
        @saveData="saveData"
      />
    </el-tab-pane>
    <el-tab-pane name="bookkeeping" label="Bookkeeping" lazy>
      <SystemSettingBookkeeping :item="item.bookkeeping" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="social" label="Social" lazy>
      <SystemSettingSocial :item="item.social" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="notification" label="Notification" lazy>
      <SystemSettingNotification
        :item="item.notification"
        @saveData="saveData"
      />
    </el-tab-pane>
    <el-tab-pane name="layout" label="Layout" lazy>
      <SystemSettingLayout :item="item.layout" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane
      v-if="$store.envs.loyalty_rewards"
      name="loyalty-rewards"
      label="Loyalty Rewards"
      lazy
    >
      <SystemSettingLoyalty :item="item.loyalty" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="mobile" label="Mobile" lazy>
      <SystemSettingMobile :item="item.mobile" @saveData="saveData" />
    </el-tab-pane>
    <el-tab-pane name="billing" label="Billing" lazy>
      <SystemSettingBraintree />
    </el-tab-pane>
    <el-tab-pane name="oauth-links" label="OAuth Links" lazy>
      <SystemSettingOauthLinks />
    </el-tab-pane>
    <el-tab-pane name="integrations" label="Integrations" lazy>
      <SystemSettingIntegrations :item="integrations" @saveData="saveData" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import SystemSettingBasic from "@/default/pages/system_settings/basic.vue";
import SystemSettingEmail from "@/default/pages/system_settings/email.vue";
import SystemSettingContainer from "@/default/pages/system_settings/container.vue";
import SystemSettingDriver from "@/default/pages/system_settings/driver.vue";
import SystemSettingQuoteEngine from "@/default/pages/system_settings/quote_engine.vue";
import SystemSettingSocial from "@/default/pages/system_settings/social.vue";
import SystemSettingBookkeeping from "@/default/pages/system_settings/bookkeeping.vue";
import SystemSettingNotification from "@/default/pages/system_settings/notification.vue";
import SystemSettingLayout from "@/default/pages/system_settings/layout.vue";
import SystemSettingLoyalty from "@/default/pages/system_settings/loyalty.vue";
import SystemSettingMobile from "@/default/pages/system_settings/mobile.vue";
import SystemSettingOauthLinks from "@/default/pages/system_settings/oauth_links.vue";
import SystemSettingBraintree from "@/default/pages/signups/trucker/method.vue";
import SystemSettingIntegrations from "@/default/pages/system_settings/integrations.vue";
import CarriersProfile from "@/default/pages/carriers/profile.vue";

export default {
  name: "SystemSetting",
  components: {
    SystemSettingBasic,
    SystemSettingEmail,
    SystemSettingContainer,
    SystemSettingDriver,
    SystemSettingQuoteEngine,
    SystemSettingSocial,
    SystemSettingBookkeeping,
    SystemSettingNotification,
    SystemSettingLayout,
    SystemSettingLoyalty,
    SystemSettingMobile,
    SystemSettingBraintree,
    SystemSettingOauthLinks,
    SystemSettingIntegrations,
    CarriersProfile,
  },
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      activeTab: "basic",
      item: {},
      nestedKeys: [
        "email",
        "container",
        "driver",
        "task",
        "quote_engine",
        "bookkeeping",
        "social",
        "notification",
        "layout",
        "loyalty",
        "mobile",
        "open_track",
        "gnosis",
        "apm",
        "avantida",
        "port_of_houston",
        "draydog",
        "google_drive",
      ],
    };
  },
  computed: {
    integrations() {
      return {
        open_track: this.item.open_track,
        gnosis: this.item.gnosis,
        avantida: this.item.avantida,
        apm: this.item.apm,
        port_of_houston: this.item.port_of_houston,
        draydog: this.item.draydog,
        google_drive: this.item.google_drive,
      };
    },
  },
  methods: {
    async loadData() {
      try {
        const response = await this.$http.get("/api/v1/system_settings");
        this.item = response.data;
        this.nestedKeys.forEach((key) => (this.item[key] ||= {}));

        let anchor = window.location.hash.slice(1);
        if (anchor === "quickbooks") {
          anchor = "oauth-links";
        }
        if (anchor != "") this.activeTab = anchor;
      } catch (err) {}
    },
    setErrors(errors, context) {
      if (context) {
        this.$set(this.item[context], "errors", errors);
      } else {
        this.$set(this.item, "errors", errors);
      }
    },
    async saveData(data, context, reload = false) {
      try {
        await this.$http.put("/api/v1/system_settings/0.json", {
          system_setting: data,
          context: context,
        });
        this.$message({
          message: "The data was saved successfully.",
          type: "success",
        });
        this.setErrors(null, context);
        if (reload) await this.loadData();
      } catch (ex) {
        this.setErrors(ex.response.data.errors, context);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.system-setting-tabs::v-deep {
  .el-tabs__content {
    @apply max-h-[calc(100vh-155px)] overflow-auto;
  }
}
</style>
